import Repository from "./Repository";

const resource = "/foods";

export default {
  get(part, headers) {
    return Repository.get(`${resource}/${part}`, { headers });
  },
  getFromTo(part, headers) {
    return Repository.get(`${resource}/${part}`, { headers });
  },
  post(part, body, headers) {
    return Repository.post(`${resource}/${part}`, body, { headers });
  },
  put(part, body, headers) {
    return Repository.put(`${resource}/${part}`, body, { headers });
  }
};



// WEBPACK FOOTER //
// ./src/repositories/FoodsRepository.js